import { type FC, type PropsWithChildren } from "react";

import { Heading2 } from "@/components/flexkit/typography/Headings";

type Props = PropsWithChildren & {
    title: string;
    description: string;
    "data-testid"?: string;
};
export const EmptyStateCard: FC<Props> = ({ title, description, children, "data-testid": dataTestId }) => {
    return (
        <div
            className="flex flex-col items-center gap-4 overflow-hidden rounded-xl border-[0.5px] border-border-base bg-surface-primary px-5 py-4"
            data-testid={dataTestId ?? "empty-state-card"}
        >
            <div className="flex flex-col items-center gap-2 py-10 text-center">
                <Heading2 className="text-xl text-content-primary">{title}</Heading2>
                <div className="text-base text-content-secondary">{description}</div>
                {children && <div className="mt-4 flex flex-row gap-2">{children}</div>}
            </div>
        </div>
    );
};
